import React, { useContext, useState } from "react";
import { GlobalContext } from "../context/provider";
import checkaction from "../context/action/login/checkaction";
import { FaUser, FaLock } from "react-icons/fa";

const Login = () => {
  const { initState, initDispatch, recaller, setrecaller } = useContext(GlobalContext);
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);

  const handleLogin = () => {
    if (!username) {
      seterror(true);
      return false;
    }
    if (!password) {
      seterror1(true);
      return false;
    }
    initDispatch({ type: "authcheckFalse" });
    checkaction(username, password)(initDispatch)(recaller)(setrecaller);
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white rounded-xl shadow-2xl p-6 sm:p-8">
        {/* Logo/Header Section */}
        {/* <div className="text-center">
          <h2 className="mt-6 text-3xl font-bold text-gray-900">
            سیستەمی بەڕێوەبردنی کۆگا
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            تکایە داخڵبوون ئەنجام بدە
          </p>
        </div> */}

        {/* Form Section */}
        <form className="mt-8 space-y-6" onSubmit={(e) => e.preventDefault()}>
          {/* Username Field */}
          <div>
            <label
              className={`block text-sm font-medium mb-2 
                ${error ? "text-red-500" : "text-gray-700"}`}
            >
              ناوی بەکارهێنەر
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FaUser className={`h-5 w-5 ${error ? "text-red-400" : "text-gray-400"}`} />
              </div>
              <input
                type="text"
                className={`appearance-none block w-full pl-10 pr-4 py-3 
                  border rounded-lg text-gray-900 placeholder-gray-500
                  focus:outline-none focus:ring-2 focus:ring-offset-2 
                  transition duration-150 ease-in-out
                  ${error 
                    ? "border-red-300 focus:border-red-500 focus:ring-red-500" 
                    : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"}`}
                placeholder="ناوی بەکارهێنەر"
                value={username}
                onChange={(e) => setusername(e.target.value)}
                onFocus={() => seterror(false)}
              />
            </div>
          </div>

          {/* Password Field */}
          <div>
            <label
              className={`block text-sm font-medium mb-2 
                ${error1 ? "text-red-500" : "text-gray-700"}`}
            >
              تێپەڕەوشە
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FaLock className={`h-5 w-5 ${error1 ? "text-red-400" : "text-gray-400"}`} />
              </div>
              <input
                type="password"
                className={`appearance-none block w-full pl-10 pr-4 py-3 
                  border rounded-lg text-gray-900 placeholder-gray-500
                  focus:outline-none focus:ring-2 focus:ring-offset-2 
                  transition duration-150 ease-in-out
                  ${error1 
                    ? "border-red-300 focus:border-red-500 focus:ring-red-500" 
                    : "border-gray-300 focus:border-blue-500 focus:ring-blue-500"}`}
                placeholder="********"
                value={password}
                onChange={(e) => setpassword(e.target.value)}
                onFocus={() => seterror1(false)}
              />
            </div>
          </div>

          {/* Login Button */}
          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-3 px-4 
                border border-transparent text-sm font-medium rounded-lg text-white 
                bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 
                focus:ring-offset-2 focus:ring-blue-500 transition duration-150 ease-in-out"
              onClick={handleLogin}
            >
              داخڵبوون
            </button>
          </div>
        </form>

        {/* Error Message */}
        {initState.authcheck && (
          <div className="mt-4 text-center text-red-600 bg-red-100 rounded-lg py-2 px-4">
            ناوی بەکارهێنەر یان تێپەڕەوشە هەڵەیە
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
